import styled from "styled-components";

export const Body1 = styled.div`
  font-size: ${(props) => props.theme.Web_fontSizes.Body1};
  font-weight: ${(props) => props.theme.fontWeights.Body1};
  line-height: ${(props) => props.theme.LineHeight.Body1};
  color: #000;
  color: ${(props) => props.$color};
  font-family: "NotoSansKR";
  margin-right: 15px;
  text-decoration: none;
  text-decoration-line: none;
  cursor: pointer;
`;

export const TopBar = styled.div`
  width: 100%;
  height: 82px;
  background: #ffffff;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 35px;
`;

// 좌측: 관리자 페이지 공지(📢 + 내용). 길면 말줄임. 공지가 없으면 비워둔다.
export const NoticeArea = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
  margin-right: 20px;
`;

export const NoticeText = styled.div`
  font-family: "NotoSansKR";
  font-size: 18px;
  font-weight: 400;
  color: #111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// 우측: 사용자명 + 로그아웃
export const RightArea = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
